import { useMutation } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useGlobalStore } from "../stores/globalStore";
import { qualifyProductOffers } from "../api/client";

export const useQualifyProductOffers = () => {
    const { shoppingCart } = useGlobalStore(
        useShallow((state) => ({
            shoppingCart: state.shoppingCart,
        }))
    );

    const ocId: string = shoppingCart?.offerContainer?.[0]?.id ?? "";

    const { mutateAsync: fetchQualifyProductOffers } = useMutation({
        mutationFn: () => {
            return qualifyProductOffers({ shoppingCart, ocId });
        },
    });

    return fetchQualifyProductOffers;
}